import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { VideoActionTypes } from './action';
// import * as Sentry from "@sentry/browser";

function* fetchIssueTag() {
  while (true) {
    const { payload: { currentPage = 1 } = {} } = yield take(VideoActionTypes.RANDOM_ISSUE_TAGS);
    try {
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/video/inquiry/symptom/list/page',
        // url: 'https://www.fastmock.site/mock/f0acd00935863f631eae4867fccc48d6/api/ump/inquiry/symptom/list/page',
        type: 'GET',
        data: {
          pageSize: 6,
          currentPage,
        },
        isloading: false,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        yield put({ type: VideoActionTypes.RANDOM_ISSUE_TAGS_REDUCER, data: result || {} });
      }
    } catch (error) {
      // Sentry.captureException(error);
      // StaticToast.error('fetch_address_list--------' + error.message);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* fetchHasFavorite() {
  while (true) {
    const { payload = {} } = yield take(VideoActionTypes.HAS_FAVORITE);
    try {
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/video/inquiry/favorite/list/page',
        // url: 'https://www.fastmock.site/mock/f0acd00935863f631eae4867fccc48d6/api/ump/inquiry/favorite/list/page',
        type: 'GET',
        data: {
          pageSize: 30,
          currentPage: 1,
          patientId: payload.patientId,
        },
        isloading: false,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        yield put({ type: VideoActionTypes.HAS_FAVORITE_REDUCER, data: result.resultList || [] });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

/*
function* fetchProductList() {
  while (true) {
    const { onSuccess } = yield take(VideoActionTypes.PRODUCT_LIST);
    try {
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/product/list',
        // url: 'https://www.fastmock.site/mock/f0acd00935863f631eae4867fccc48d6/api/ump/inquiry/favorite/list/page',
        type: 'POST',
        data: { productCode: "VIDEO_INQUIRY" },
        needLogin: false,
        isloading: true
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        yield put({ type: VideoActionTypes.PRODUCT_LIST_REDUCER, data: result });
        onSuccess && onSuccess(result);
      }
    } catch (error) {
      Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      onSuccess && onSuccess([]);
    }
  }
}
*/


export default function* root() {
  yield all([
    fork(fetchIssueTag),
    fork(fetchHasFavorite),
    // fork(fetchProductList),
  ]);
}
